import { FormItem, TextInput } from '@framework/form';
import { RowElement } from '@framework/ui';
import React, { useMemo } from 'react';
import { useTreeReferencesContext } from '../../../../../tree/references';
import { ReferenceType } from '../../../../expressions/references/IReference';
import { resolveTreeReferences } from '../../../../expressions/references/resolve/resolveTreeReferences';
import { AlignmentSelectInput } from '../../common/AlignmentSelectInput';
import { ButtonTypeSelectInput } from '../../common/ButtonTypeSelectInput';
import { IconTypeSelectInput } from '../../common/IconTypeSelectInput';
import { IconType } from '../buttons/icons/Icons';
import { ButtonType } from '../buttons/types/ButtonEnums';

export function ConfirmWidgetConfigComponent() {
  const { widget, root } = useTreeReferencesContext();

  const connectableWidgets = useMemo(() => {
    if (!root || !widget) return [];

    return resolveTreeReferences(root, widget).filter(
      r => r.type === ReferenceType.Widget,
    );
  }, [root, widget]);

  return (
    <div>
      <RowElement>
        <FormItem name="code" label="Codice">
          <TextInput name="code" />
        </FormItem>
      </RowElement>
      <RowElement>
        <FormItem name="layout.confirmIcon" label="Icona pulsante conferma">
          <IconTypeSelectInput
            name="layout.confirmIcon"
            defaultValue={IconType.Nessuna}
          />
        </FormItem>
        <FormItem name="layout.confirmText" label="Testo pulsante conferma">
          <TextInput name="layout.confirmText" />
        </FormItem>
        <FormItem
          name="layout.confirmButtonType"
          label="Tipo pulsante conferma"
        >
          <ButtonTypeSelectInput
            name="layout.confirmButtonType"
            defaultValue={ButtonType.Primary}
          />
        </FormItem>
      </RowElement>
      <RowElement>
        <FormItem name="layout.editIcon" label="Icona pulsante modifica">
          <IconTypeSelectInput
            name="layout.editIcon"
            defaultValue={IconType.Nessuna}
          />
        </FormItem>
        <FormItem name="layout.editText" label="Testo pulsante modifica">
          <TextInput name="layout.editText" />
        </FormItem>
        <FormItem name="layout.editButtonType" label="Tipo pulsante modifica">
          <ButtonTypeSelectInput
            name="layout.editButtonType"
            defaultValue={ButtonType.Default}
          />
        </FormItem>
      </RowElement>
      <FormItem name="layout.buttonsAlign" label="Allineamento bottoni">
        <AlignmentSelectInput name="layout.buttonsAlign" />
      </FormItem>
    </div>
  );
}
